var _path, _path2, _path3, _path4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4448 62.6394C51.2325 62.6394 59.167 54.7049 59.167 44.9172C59.167 35.1296 51.2325 27.1951 41.4448 27.1951C31.6571 27.1951 23.7227 35.1296 23.7227 44.9172C23.7227 54.7049 31.6571 62.6394 41.4448 62.6394Z",
    stroke: "#2A2E34",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5616 52.3681C85.7591 49.0205 90.5013 38.8508 87.1537 29.6533C83.8061 20.4559 73.6364 15.7137 64.439 19.0613",
    stroke: "#2A2E34",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 106.948V89.2258C6 84.3319 9.96724 80.3647 14.8611 80.3647H68.0276C72.9216 80.3647 76.8887 84.3319 76.8887 89.2258V106.948",
    stroke: "#2A2E34",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9644 67.5027H86.6102C91.5041 67.5027 95.4713 71.4698 95.4713 76.3638V90.4368V97.4732",
    stroke: "#2A2E34",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 24,
    x2: 112,
    y2: 24,
    stroke: "#2A2E34",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicant);
export default __webpack_public_path__ + "static/media/applicant.75a4728b686c87b439a805d64d813805.svg";
export { ForwardRef as ReactComponent };